/* PonyHütchen Weihnachtsland — Schneefall, Countdown, AJAX-Warenkorb, Budgetfilter, Nav.
   Wird von mehreren Sektionen geladen; der Guard sorgt dafür, dass alles nur einmal initialisiert. */
(function () {
  if (window.__xmasLand) return;
  window.__xmasLand = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- Schneefall (nur sichtbar, nur ohne reduced motion) ---------- */
  function initSnow(canvas) {
    if (reduceMotion || canvas.__init) return;
    canvas.__init = true;
    var ctx = canvas.getContext('2d');
    var density = parseInt(canvas.dataset.density || '90', 10);
    var flakes = [];
    var w, h, dpr, raf, visible = false;

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(density * Math.min(1, w / 1200) + density * 0.25);
      flakes = [];
      for (var i = 0; i < n; i++) flakes.push(make(true));
    }
    function make(anyY) {
      var r = Math.random() * 2.2 + 0.6;
      return { x: Math.random() * w, y: anyY ? Math.random() * h : -6, r: r, vy: r * 0.35 + 0.25, vx: Math.random() * 0.4 - 0.2, p: Math.random() * Math.PI * 2, o: Math.random() * 0.5 + 0.35 };
    }
    function tick() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.p += 0.012;
        f.y += f.vy;
        f.x += f.vx + Math.sin(f.p) * 0.3;
        if (f.y > h + 6) flakes[i] = make(false);
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,' + f.o + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    }
    resize();
    window.addEventListener('resize', debounce(resize, 200));
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      cancelAnimationFrame(raf);
      if (visible && !document.hidden) tick();
    }).observe(canvas);
    document.addEventListener('visibilitychange', function () {
      cancelAnimationFrame(raf);
      if (visible && !document.hidden) tick();
    });
  }

  /* ---------- Countdown bis Bestellschluss ---------- */
  function initCountdown(el) {
    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;
    var units = {
      d: el.querySelector('[data-u="d"]'),
      h: el.querySelector('[data-u="h"]'),
      m: el.querySelector('[data-u="m"]')
    };
    var expired = document.querySelectorAll('[data-xmas-expired]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function render() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        expired.forEach(function (x) { x.hidden = false; });
        return false;
      }
      var d = Math.floor(diff / 864e5);
      var h = Math.floor((diff % 864e5) / 36e5);
      var m = Math.floor((diff % 36e5) / 6e4);
      if (units.d) units.d.textContent = d;
      if (units.h) units.h.textContent = pad(h);
      if (units.m) units.m.textContent = pad(m);
      el.hidden = false;
      return true;
    }
    if (render()) {
      var t = setInterval(function () { if (!render()) clearInterval(t); }, 30000);
    }
  }

  /* ---------- Liefer-Timeline: vergangene Schritte markieren ---------- */
  function initTimeline(list) {
    var now = Date.now();
    var nextSet = false;
    list.querySelectorAll('[data-date]').forEach(function (step) {
      var t = new Date(step.dataset.date + 'T23:59:59').getTime();
      if (isNaN(t)) return;
      if (t < now) step.classList.add('is-past');
      else if (!nextSet) { step.classList.add('is-next'); nextSet = true; }
    });
  }

  /* Texte kommen aus den Hero-Einstellungen (Theme-Editor), sonst Standardtexte */
  function texts() {
    var el = document.querySelector('[data-xmas-texts]');
    var t = el ? el.dataset.xmasTexts.split('|') : [];
    return {
      added: t[0] || '[produkt] liegt im Geschenkesack',
      addedMulti: t[1] || 'Deine Geschenke liegen im Geschenkesack',
      error: t[2] || 'Das hat leider nicht geklappt – bitte versuch es nochmal.'
    };
  }

  /* ---------- AJAX in den Warenkorb ---------- */
  function addToCart(btn) {
    var id = btn.dataset.variantId;
    var form = btn.closest('[data-xmas-product]');
    var select = form && form.querySelector('.xmas-card__variant');
    if (select) id = select.value;
    // data-variant-ids="1,2" legt mehrere Artikel auf einmal ab (Bestseller-Duo ohne Bundle-Produkt)
    var ids = btn.dataset.variantIds ? btn.dataset.variantIds.split(',') : [id];
    ids = ids.filter(Boolean);
    if (!ids.length) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (i) { return { id: parseInt(i, 10), quantity: 1 }; }) })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var n = data.items ? data.items.length : 0;
        var tx = texts();
        toast(n > 1 ? tx.addedMulti : tx.added.replace('[produkt]', n === 1 ? (btn.dataset.title || data.items[0].product_title) : '').trim());
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        toast((err && err.description) || texts().error);
      });
  }

  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'xmas-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8S10.5 3 7.5 3 6 6 7.5 7 12 8 12 8zm0 0s1.5-5 4.5-5S18 6 16.5 7 12 8 12 8z"/></svg>';
    toastEl.appendChild(document.createTextNode(msg));
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-xmas-atc]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* Variantenwahl in Karte: Preis/Verfügbarkeit nachziehen */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.xmas-card__variant');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('[data-xmas-product]');
    var price = card.querySelector('[data-xmas-price]');
    var btn = card.querySelector('[data-xmas-atc]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    if (btn) btn.disabled = opt.dataset.available !== 'true';
    card.dataset.price = opt.dataset.cents;
  });

  /* ---------- Budgetfilter ---------- */
  function initBudget(wrap) {
    var chips = wrap.querySelectorAll('[data-min]');
    var result = wrap.querySelector('.xmas-budget__result');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') !== 'true';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        var cards = document.querySelectorAll('[data-xmas-product][data-price]');
        cards.forEach(function (c) { c.classList.remove('is-match'); });
        if (!on) {
          document.body.classList.remove('xmas-budget-on');
          result.textContent = '';
          result.classList.remove('is-on');
          return;
        }
        chip.setAttribute('aria-pressed', 'true');
        var min = parseFloat(chip.dataset.min) * 100;
        var max = chip.dataset.max ? parseFloat(chip.dataset.max) * 100 : Infinity;
        var first = null, count = 0;
        cards.forEach(function (c) {
          var p = parseInt(c.dataset.price, 10);
          if (p >= min && p <= max) {
            c.classList.add('is-match');
            count++;
            if (!first) first = c;
          }
        });
        document.body.classList.add('xmas-budget-on');
        result.innerHTML = '';
        result.classList.add('is-on');
        if (count) {
          var label = count === 1 ? (wrap.dataset.one || '1 Geschenk passt') : (wrap.dataset.many || '[anzahl] Geschenke passen').replace('[anzahl]', count);
          var txt = document.createElement('span');
          txt.className = 'xmas-budget__count';
          txt.textContent = label;
          result.appendChild(txt);
          var show = (wrap.dataset.show || 'Zeig sie mir');
          var a = document.createElement('a');
          a.href = '#';
          a.className = 'xmas-btn xmas-btn--gold xmas-btn--sm';
          a.textContent = show.charAt(0).toUpperCase() + show.slice(1);
          a.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg>');
          a.addEventListener('click', function (ev) {
            ev.preventDefault();
            first.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          });
          result.appendChild(a);
        } else {
          var none = document.createElement('span');
          none.textContent = wrap.dataset.none || 'In dieser Preisklasse ist gerade nichts mehr da – schau dir unsere Geschenksets an.';
          result.appendChild(none);
        }
        var reset = document.createElement('button');
        reset.type = 'button';
        reset.className = 'xmas-budget__reset';
        reset.textContent = wrap.dataset.reset || 'Alle zeigen';
        reset.addEventListener('click', function () { chip.click(); });
        result.appendChild(reset);
      });
    });
  }

  /* ---------- Geschenke-Finder: Art × Duftrichtung × Budget ---------- */
  function initFinder(wrap) {
    if (wrap.__init) return;
    wrap.__init = true;
    var d = wrap.dataset;
    var b1 = parseFloat(d.b1 || '15') * 100, b2 = parseFloat(d.b2 || '30') * 100;
    var state = { art: '', duft: '', budget: '' };
    var countEl = wrap.querySelector('.xmas-gf__count');
    var strip = wrap.querySelector('.xmas-gf__strip');
    var reset = wrap.querySelector('.xmas-gf__reset');
    var result = wrap.querySelector('.xmas-gf__result');
    var browse = wrap.querySelector('.xmas-gf__browse');
    var giftIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M12 8v13M3 12h18M12 8S10.5 3 7.5 3 6 6 7.5 7 12 8 12 8zm0 0s1.5-5 4.5-5S18 6 16.5 7 12 8 12 8z"/></svg>';

    function esc(t) { var x = document.createElement('div'); x.textContent = t || ''; return x.innerHTML; }
    function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

    // Alle Produkte der Seite einsammeln (Duplikate über Name zusammenfassen)
    function collect() {
      var seen = {}, list = [];
      document.querySelectorAll('[data-xmas-product][data-f-name]').forEach(function (el) {
        var name = el.dataset.fName;
        if (!name || seen[name]) return;
        seen[name] = true;
        list.push({
          el: el,
          name: name,
          kind: el.dataset.fKind || 'single',
          unit: el.dataset.fUnit || '',
          duft: (el.dataset.fDuft || '').split(/\s+/).filter(Boolean),
          price: parseInt(el.dataset.price || '0', 10),
          // Preis nur fürs Budget hinterlegt (noch kein echter/Vorschau-Preis) → nicht anzeigen
          showPrice: el.dataset.fNoprice !== '1',
          img: el.dataset.fImg || '',
          url: el.dataset.fUrl || '',
          variant: el.dataset.fVariant || '',
          state: el.dataset.fState || 'ok'
        });
      });
      return list;
    }
    var items = collect();
    wrap.__refresh = function () { items = collect(); render(); };

    function band(p) { return p <= 0 ? '' : p <= b1 ? '1' : p <= b2 ? '2' : '3'; }

    function render() {
      // Ohne Auswahl: Stöber-Einladung statt Produktreihe
      var active = !!(state.art || state.duft || state.budget);
      if (result) result.hidden = !active;
      if (browse) browse.hidden = active;
      if (!active) { strip.innerHTML = ''; strip.__hits = []; return; }
      var hits = items.filter(function (it) {
        if (state.art && it.kind !== state.art) return false;
        if (state.duft && it.duft.indexOf(state.duft) === -1) return false;
        if (state.budget && band(it.price) !== state.budget) return false;
        return true;
      });
      var n = hits.length;
      countEl.textContent = n === 0 ? (d.none || 'Keine Treffer') : n === 1 ? (d.one || '1 Geschenk passt') : (d.many || '[anzahl] Geschenke passen').replace('[anzahl]', n);
      reset.hidden = !(state.art || state.duft || state.budget);
      strip.innerHTML = hits.map(function (it, i) {
        var media = it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '<span class="xmas-gf__ph">' + giftIcon + '</span>';
        var price = it.price > 0 && it.showPrice ? '<b class="xmas-gf__price">' + money(it.price) + (it.unit ? '<small>' + esc(it.unit) + '</small>' : '') + '</b>' : '';
        var action;
        if (it.state === 'ok' && it.variant) {
          action = '<button type="button" class="xmas-btn xmas-btn--sm xmas-btn--block xmas-gf__add" data-xmas-atc data-variant-id="' + esc(it.variant) + '" data-title="' + esc(it.name) + '">' + esc(d.add || 'In den Geschenkesack') + '</button>';
        } else {
          action = '<span class="xmas-gf__state">' + esc(it.state === 'soon' ? (d.soon || 'Bald erhältlich') : (d.soldout || 'Ausverkauft')) + '</span>';
        }
        var title = it.url ? '<a href="' + esc(it.url) + '">' + esc(it.name) + '</a>' : esc(it.name);
        return '<article class="xmas-gf__item" data-i="' + i + '">' +
          '<button type="button" class="xmas-gf__media" data-jump="' + i + '" aria-label="' + esc(it.name) + ' auf der Seite zeigen">' + media + '</button>' +
          '<h3>' + title + '</h3>' + price + action + '</article>';
      }).join('');
      strip.scrollLeft = 0;
      strip.__hits = hits;
    }

    wrap.querySelectorAll('[data-group]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('.xmas-gf__chip');
        if (!chip) return;
        group.querySelectorAll('.xmas-gf__chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        state[group.dataset.group] = chip.dataset.v;
        render();
      });
    });
    reset.addEventListener('click', function () {
      state = { art: '', duft: '', budget: '' };
      wrap.querySelectorAll('[data-group]').forEach(function (g) {
        g.querySelectorAll('.xmas-gf__chip').forEach(function (c, i) { c.setAttribute('aria-pressed', i === 0 ? 'true' : 'false'); });
      });
      render();
    });
    // Klick aufs Bild: zur Karte auf der Seite springen und kurz hervorheben
    strip.addEventListener('click', function (e) {
      var j = e.target.closest('[data-jump]');
      if (!j || !strip.__hits) return;
      var it = strip.__hits[parseInt(j.dataset.jump, 10)];
      if (!it) return;
      var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      var nav = document.querySelector('.xmas-nav');
      var top = it.el.getBoundingClientRect().top + window.pageYOffset - header - (nav ? nav.offsetHeight : 0) - 24;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      it.el.classList.add('xmas-flash');
      setTimeout(function () { it.el.classList.remove('xmas-flash'); }, 2200);
    });
    render();
  }

  /* ---------- Sticky Nav: aktiver Abschnitt ---------- */
  function initNav(nav) {
    var links = nav.querySelectorAll('a[href^="#"]');
    var map = {};
    var design = window.Shopify && Shopify.designMode;
    links.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) map[t.id] = a;
      // Link ohne Ziel: im Shop ausblenden, im Editor durchgestrichen zeigen
      else if (design) a.style.textDecoration = 'line-through';
      else a.parentElement.hidden = true;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (l) { l.classList.remove('is-active'); });
        var a = map[en.target.id];
        if (a) {
          a.classList.add('is-active');
          var list = a.closest('.xmas-nav__list');
          if (list && list.scrollWidth > list.clientWidth) {
            list.scrollTo({ left: a.offsetLeft - list.clientWidth / 2 + a.offsetWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  /* Ankerlinks mit Offset für Header + Sticky-Nav */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.xmas a[href^="#"], .xmas-nav a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var target = document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    var header = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    var nav = document.querySelector('.xmas-nav');
    var off = header + (nav ? nav.offsetHeight : 0) + 8;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + target.id);
  });

  /* ---------- Reveal ---------- */
  function initReveal(scope) {
    var els = scope.querySelectorAll('[data-xmas-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.xmas-snow-canvas').forEach(initSnow);
    scope.querySelectorAll('[data-xmas-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-xmas-timeline]').forEach(initTimeline);
    scope.querySelectorAll('[data-xmas-budget]').forEach(initBudget);
    scope.querySelectorAll('[data-xmas-finder]').forEach(initFinder);
    scope.querySelectorAll('[data-xmas-nav]').forEach(initNav);
    initReveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme-Editor: neu geladene Sektionen initialisieren */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    // Andere Sektion neu geladen (Theme-Editor): Finder-Ergebnisse neu einsammeln
    document.querySelectorAll('[data-xmas-finder]').forEach(function (f) { if (f.__refresh) f.__refresh(); });
  });
})();
